import React, { useEffect, useState } from 'react';
import { CHAPTERS } from '../data/mock';

export default function SideNav() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const secs = document.querySelectorAll('.chapter');
      const y = window.scrollY + window.innerHeight * 0.4;
      let cur = 0;
      secs.forEach((s, i) => {
        if (s.offsetTop <= y) cur = i;
      });
      setActive(cur);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <aside className="side-nav font-sans">
      {CHAPTERS.map((c, i) => (
        <a key={c.num} href={`#l${i + 1}`} className={i === active ? 'active' : ''}>
          <span className="dot" />
          <span>{c.num}</span>
        </a>
      ))}
    </aside>
  );
}
